import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {
  isRegressionTypeChartParameters,
  ParametersOverride,
} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import {RegressionConfig, RegressionType} from 'ui-library/charting/statistics/regression/RegressionTypes';

export default function getRegressionType(
  analyticsVisualization: AnalyticsVisualization
): RegressionType | null {
  const parameters = analyticsVisualization.parameters as ParametersOverride;
  return isRegressionTypeChartParameters(parameters)
    ? getRegressionTypeFromConfig(parameters.regressionConfig)
    : null;
}

export function getRegressionTypeFromConfig(
  regressionConfig: RegressionConfig | null
): RegressionType | null {
  return regressionConfig?.regressionType ?? null;
}
